import { render, staticRenderFns } from "./AgentConsole.vue?vue&type=template&id=860b8a1a&scoped=true"
import script from "./AgentConsole.vue?vue&type=script&lang=js"
export * from "./AgentConsole.vue?vue&type=script&lang=js"
import style0 from "./AgentConsole.vue?vue&type=style&index=0&id=860b8a1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "860b8a1a",
  null
  
)

export default component.exports